import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { SERVICES } from "../data/content";

export default function ServicesShowcase() {
  const [active, setActive] = useState(0);

  return (
    <div className="mt-16 border-t border-white/10" data-testid="services-showcase">
      {SERVICES.map((s, i) => {
        const Icon = s.icon;
        const isActive = active === i;
        return (
          <Reveal key={s.title} delay={i * 0.05}>
            <div
              onMouseEnter={() => setActive(i)}
              onClick={() => setActive(i)}
              className="group border-b border-white/10 cursor-pointer"
              data-testid={`service-row-${i}`}
            >
              <div className="py-6 md:py-8 flex items-center gap-5 md:gap-10">
                <span
                  className={`font-display text-base md:text-lg tabular-nums transition-colors duration-500 shrink-0 ${
                    isActive ? "text-white" : "text-neutral-600"
                  }`}
                >
                  0{i + 1}
                </span>

                <h3
                  className={`flex-1 min-w-0 font-display text-2xl md:text-4xl lg:text-5xl tracking-tight font-medium transition-all duration-500 ${
                    isActive ? "text-white md:translate-x-2" : "text-neutral-500"
                  }`}
                >
                  {s.title}
                </h3>

                <span
                  className={`hidden md:flex h-12 w-12 shrink-0 items-center justify-center rounded-full border transition-all duration-500 ${
                    isActive ? "border-white/40 bg-white/5 opacity-100 rotate-0" : "border-white/10 opacity-40 -rotate-12"
                  }`}
                >
                  <Icon size={22} strokeWidth={1.4} className="text-white" />
                </span>
              </div>

              <AnimatePresence initial={false}>
                {isActive && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                    className="overflow-hidden"
                  >
                    <div className="pb-9 md:pl-[3.5rem] grid md:grid-cols-12 gap-4 md:gap-10">
                      <p className="md:col-span-4 font-display text-lg md:text-xl tracking-tight text-neutral-300">
                        {s.short}
                      </p>
                      <p className="md:col-span-7 md:col-start-6 text-neutral-400 leading-relaxed max-w-2xl">
                        {s.desc}
                      </p>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
}
